import { useState } from 'react';
import { toast } from 'react-toastify';
import { delIntegrationApi } from '../../../api/api';
import { useIntegrationsStore } from '../../../stores/use-integrations-store';

const initialPendingDelete = { id: null, key: null, device_id: null, integration_name: '' };

export const useDeleteIntegration = () => {
  const { fetchIntegrations } = useIntegrationsStore();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [pendingDelete, setPendingDelete] = useState(initialPendingDelete);

  const handleDeleteClick = (id, key, device_id, integration_name) => {
    setPendingDelete({ id, key, device_id, integration_name });
    setConfirmOpen(true);
  };

  const handleConfirm = async () => {
    const { id, key, device_id } = pendingDelete;

    if (!device_id) return;
    try {
      await delIntegrationApi(
        id,
        key,
        device_id,
        () => {},
        (err) => {
          toast.error(err.error, { hideProgressBar: true });
        }
      );

      await fetchIntegrations();
    } catch (e) {
      toast.error('Ошибка при удалении интеграции', { hideProgressBar: true });
    } finally {
      setConfirmOpen(false);
      setPendingDelete(initialPendingDelete);
    }
  };

  return {
    confirmOpen,
    setConfirmOpen,
    pendingDelete,
    handleDeleteClick,
    handleConfirm,
  };
};
